const SAND = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    <rect x="0.715576" width="20" height="20" fill="#62BDEB" />
    <path
      d="M12.2094 7.22561V5.98781H9.39236V8.71951H14.9411L16.2643 10.0427V15.6768L14.9411 17H6.66065L5.16675 15.5061V12.8598H9.39236V14.1829H12.2094V11.5366H6.66065L5.16675 10.0427V4.4939L6.66065 3H14.9411L16.2643 4.32317V7.22561H12.2094Z"
      fill="white"
    />
  </svg>
);
export default SAND;
